import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { assertSuccessEnvelope } from '../http/api-envelope.operators';
import type { ApiEnvelope } from './super-admin-auth.service';

export interface ProductOption {
  id: number;
  name: string;
  slug: string;
}

export interface ProductDocument {
  code: string;
  requirement_key: string;
  display_name: string;
  hint: string;
  required: boolean;
  order: number;
  capture_modes: string[];
  selected: boolean;
}

export interface ProductDocumentUpdateItem {
  code: string;
  selected: boolean;
  required: boolean;
  order: number;
}

@Injectable({ providedIn: 'root' })
export class ProductApiService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiBaseUrl.replace(/\/$/, '');

  /** Active products for the picker — never a hardcoded list. */
  listForDropdown(): Observable<ApiEnvelope<ProductOption[]>> {
    return this.http
      .get<ApiEnvelope<ProductOption[]>>(`${this.base}/product/dropdown`)
      .pipe(assertSuccessEnvelope());
  }

  /** The documents this product currently collects. */
  listDocuments(slug: string): Observable<ApiEnvelope<ProductDocument[]>> {
    return this.http
      .get<ApiEnvelope<ProductDocument[]>>(`${this.base}/product/${slug}/documents`)
      .pipe(assertSuccessEnvelope());
  }

  /** Every active registry document, flagged with whether this product currently collects it. */
  listDocumentCatalogue(slug: string): Observable<ApiEnvelope<ProductDocument[]>> {
    const params = new HttpParams().set('catalogue', 'true');
    return this.http
      .get<ApiEnvelope<ProductDocument[]>>(`${this.base}/product/${slug}/documents`, { params })
      .pipe(assertSuccessEnvelope());
  }

  updateDocuments(
    slug: string,
    items: ProductDocumentUpdateItem[],
  ): Observable<ApiEnvelope<ProductDocument[]>> {
    return this.http
      .put<ApiEnvelope<ProductDocument[]>>(`${this.base}/product/${slug}/documents`, { items })
      .pipe(assertSuccessEnvelope());
  }
}
